export default __webpack_public_path__ + "static/media/teams.7dfa3203.svg";